module.exports = __webpack_public_path__ + "media/images/bet__wrongMarker@2x-0621c7588a9568cbef41ea7eb94b4618.png";